import styled from '@emotion/styled';
import svg from '../../public/images/user-account.svg';

export default styled(svg)``;
